export const OfferStatus = {
  waiting_subscription: "En cours de validation",
  on_market: "Paramétrage en cours",
  waiting_payment: "En attente de paiement",
  running: "En cours",
  done: "Campagne terminée",
};
